import { ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { userSchema } from '@/schemas/userSchema'


export const useUserForm = (formType: 'add' | 'edit' | 'view' | 'delete' = 'add') => {
  const toast = useToast()
  const loading = ref(false)

  const { values, handleSubmit, errors, setErrors, resetForm, meta } = useForm({
    validationSchema: toTypedSchema(userSchema)
  })

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  return {
    values,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    meta,
    loading,
    showToast,
    formType
  }
}